import React from 'react'
import Box from '@mui/material/Box'
import NextImage from 'next/image'
import VariantImages from '@/assets/VariantImages'
import LinearProgress from '@mui/material/LinearProgress'
import { usePetsittingMode } from '@/store/usePetsittingMode'

const GlobalLoader: React.FC = () => {
  const { isPetsittingMode } = usePetsittingMode()
  return (
    <Box
      sx={{
        position: 'absolute',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        top: '50%',
        width: '20%',
        zIndex: 11,
      }}
    >
      <Box
        sx={{
          textAlign: 'center',
          marginBottom: '25px',
          '@keyframes fadeIn': {
            from: { opacity: 0.2 },
          },
          animation: 'fadeIn 1.3s infinite alternate',
        }}
      >
        <NextImage
          src={isPetsittingMode ? VariantImages.LogoSitterWhite : VariantImages.LogoPrimary}
          alt={'Site logo'}
          quality={100}
          style={{ objectFit: 'contain', maxWidth: '100%', margin: '0 auto' }}
        />
      </Box>
      <LinearProgress color="primary" sx={{ height: 5 }} />
    </Box>
  )
}

export default GlobalLoader
